import { TranslatedString } from '@door-vision/translation-helper'
import {SmallProductTypeFragment, ProductTypeType as GraphQLProductTypeType} from "../../../generated/graphql";
import {assertNever} from "../../utils/utils";

export interface SmallProductType {
  id: string
  type: ProductTypeType
  key: string
  translations?: TranslatedString
  doorRangePanelColumnCount?: number
  icon?: {
    svg: string
  }
}

export enum ProductTypeType {
  PRODUCT_TYPE = 'productType',
  DOOR_TYPE = 'doorType'
}

export function transformStringToProductTypeTranslations(productTypeKey: string, translations?: string | null): TranslatedString | undefined {
  if (!translations) {
    return undefined;
  }
  try {
    const parsedTranslations = JSON.parse(translations);
    return {
      default: transformProductTypeKeyToDefaultTranslation(productTypeKey),
      translations: parsedTranslations.translations || undefined,
    }
  } catch (e) {
    console.error('Failed to parse translations', e);
    return undefined;
  }
}

export function transformProductTypeKeyToDefaultTranslation(productTypeKey: string): string {
  const key = productTypeKey.toLowerCase().replace(/_/g, ' ').replace(/-/g, ' ')
  return key.charAt(0).toUpperCase() + key.slice(1);
}



export function mapSmallGraphQLProductTypeToSmallProductType(gql: SmallProductTypeFragment): SmallProductType {
  return {
    id: gql.id,
    key: gql.key,
    type: mapGraphQLProductTypeTypeToProductTypeType(gql.type),
    translations: transformStringToProductTypeTranslations(gql.key, gql.translations),
    doorRangePanelColumnCount: gql.doorRangePanelColumnCount || undefined,
    icon: gql.icon ? {
      svg: gql.icon.svg,
    } : undefined,
  };
}

export function mapGraphQLProductTypeTypeToProductTypeType(type: GraphQLProductTypeType): ProductTypeType {
  switch (type) {
    case GraphQLProductTypeType.ProductType:
      return ProductTypeType.PRODUCT_TYPE;
    case GraphQLProductTypeType.DoorType:
      return ProductTypeType.DOOR_TYPE;
    default:
      return assertNever(type);
  }
}

export function mapProductTypeTypeToGraphQLProductTypeType(type?: ProductTypeType): GraphQLProductTypeType | undefined {
  if (!type) {
    return undefined;
  }
  switch (type) {
    case ProductTypeType.PRODUCT_TYPE:
      return GraphQLProductTypeType.ProductType;
    case ProductTypeType.DOOR_TYPE:
      return GraphQLProductTypeType.DoorType;
    default:
      return assertNever(type);
  }
}
